import { useAuth } from '../auth/AuthContext'
import { Tooltip } from '@mantine/core'
import sparkleFilledIcon from '../assets/sparkle-2-filled.svg'
import { useBillingFlow } from '../billing/BillingFlowContext'

export default function BalanceChip({ amount: override }: { amount?: number }) {
  const { profile } = useAuth()
  const { openTopup } = useBillingFlow()
  const raw = typeof override === 'number' ? override : (typeof profile?.balance === 'number' ? profile.balance : 0)
  const amount = Number.isFinite(raw) ? raw : 0

  return (
    <Tooltip label="Баланс кредитов" withArrow>
      <button
        type="button"
        className="header-credit-chip"
        onClick={() => openTopup({ source: 'header_balance_chip' })}
        aria-label={`Баланс кредитов: ${amount.toFixed(0)}`}
      >
        <img src={sparkleFilledIcon} alt="" width={18} height={18} aria-hidden="true" />
        <span>{amount.toFixed(0)}</span>
      </button>
    </Tooltip>
  )
}
